import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import { CheckSquare, Square } from "lucide-react";
import { catogorySchema } from "../../Validation/Validation";

const AddSubcategory = () => {
    const navigator = useNavigate();
    const { categoryId } = useParams();
    const location = useLocation();
    const editData = location.state;
    const [loading, setLoading] = useState(false);
    const editingId = editData?._id;

    const initalvalues = {
        sortOrder: editData?.sortOrder || 1,
        name: editData?.name || "",
        label: editData?.label || "",
        url: editData?.url || "",
        speed: editData?.speed || "",
        capacity: editData?.capacity || "",
        shortDescription: editData?.shortDescription || "",
        description: editData?.description || "",
        image: editData?.image,
        bannerImage: editData?.bannerImage,
        isActive: editData?.isActive,
        showInHome: editData?.showInHome,
        parentId: editData?.parentId || categoryId || ""
    };

    const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
        useFormik({
            initialValues: initalvalues,
            validationSchema: catogorySchema,
            onSubmit: async (values) => {
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("name", values.name || "");
                    formData.append("label", values.label || "");
                    formData.append("parentId", values.parentId || "");
                    formData.append("capacity", values.capacity || "");
                    formData.append("speed", values.speed || "");
                    formData.append("shortDescription", values.shortDescription || "");
                    formData.append("description", values.description || "");
                    formData.append("sortOrder", values.sortOrder);
                    formData.append("isActive", values.isActive || false);
                    formData.append("showInHome", values.showInHome || false);

                    if (values.image instanceof File) {
                        formData.append("image", values.image);
                    }
                    if (values.bannerImage instanceof File) {
                        formData.append("bannerImage", values.bannerImage);
                    }
                    const response = editingId
                        ? await axiosInstance.put(
                            `/category/update/${editingId}`,
                            formData,
                        )
                        : await axiosInstance.post("/category/create", formData);

                    if (response.status === 200) {
                        toast.success(response.data.message);
                        navigator(-1);
                    }
                } catch (error) {
                    toast.error(error.response?.data?.message);
                    return error;
                } finally {
                    setLoading(false);
                }
            },
        });

    const breadcrumbdata = [
        { label: "Home", path: "/dashboard" },
        { label: "Category", path: "/category" },
        { label: "Subcategory", path: `/subcategory/${categoryId}` },
        { label: editingId ? "Update" : "Add", path: "*" },
    ];
    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mb-3">
                    <h3 className="custom-page-title">
                        {editingId ? "Update" : "Add"} Category
                    </h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>
                <div className="col-md-12 grid-margin stretch-card p-0">
                    <div className="card m-0">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="category-sortOrder"
                                                className="col-form-label "
                                            >
                                                Sort Order
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control border-dark "
                                                id="category-sortOrder"
                                                name="sortOrder"
                                                placeholder="Enter a category sort order"
                                                min={1}
                                                value={values.sortOrder}
                                                onChange={handleChange}
                                            />
                                            {touched.sortOrder && errors.sortOrder && (
                                                <small className="text-danger">
                                                    {errors.sortOrder}
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="banner-badge" className="col-form-label ">
                                                Category Label
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="category-label"
                                                name="label"
                                                placeholder="Enter category label"
                                                value={values.label}
                                                onChange={handleChange}
                                            />
                                            {touched.label && errors.label && (
                                                <small className="text-danger">{errors.label}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="banner-badge" className="col-form-label ">
                                                Category Url
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="category-url"
                                                name="url"
                                                placeholder="Enter category url"
                                                value={values.url}
                                                onChange={handleChange}
                                            />
                                            {touched.url && errors.url && (
                                                <small className="text-danger">{errors.url}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="banner-name" className="col-form-label ">
                                                Category Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="category-name"
                                                name="name"
                                                placeholder="Enter category name"
                                                value={values.name}
                                                onChange={handleChange}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger">{errors.name}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="category-capacity" className="col-form-label ">
                                                Category capacity
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="category-capacity"
                                                name="capacity"
                                                placeholder="Enter category capacity"
                                                value={values.capacity}
                                                onChange={handleChange}
                                            />
                                            {touched.capacity && errors.capacity && (
                                                <small className="text-danger">{errors.capacity}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="category-speed" className="col-form-label ">
                                                Category speed
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="category-speed"
                                                name="speed"
                                                placeholder="Enter category speed "
                                                value={values.speed}
                                                onChange={handleChange}
                                            />
                                            {touched.speed && errors.speed && (
                                                <small className="text-danger">{errors.speed}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="banner-shortDescription"
                                                className="col-form-label "
                                            >
                                                Short Description
                                            </label>
                                            <CodeEditor
                                                value={values.shortDescription}
                                                onChange={(val) => setFieldValue("shortDescription", val)}
                                                placeholder="Enter a shortDescription"
                                            />
                                            {touched.shortDescription && errors.shortDescription && (
                                                <small className="text-danger">{errors.shortDescription}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="slider-description"
                                                className="col-form-label "
                                            >
                                                Description
                                            </label>

                                            <CodeEditor
                                                value={values.description}
                                                onChange={(val) => setFieldValue("description", val)}
                                            />

                                            {touched.description && errors.description && (
                                                <small className="text-danger">
                                                    {errors.description}
                                                </small>
                                            )}
                                        </div>
                                    </div>


                                    <div className="col-sm-6">
                                        <ImageUploadDragAndDrop
                                            id="banner-image"
                                            label={`Desktop Image (1920 X 950px)`}
                                            value={values.image}
                                            onChange={(file) => setFieldValue("image", file)}
                                            error={errors.image}
                                            touched={touched.image}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <ImageUploadDragAndDrop
                                            id="banner-image"
                                            label={`Banner Image (1920 X 950px)`}
                                            value={values.bannerImage}
                                            onChange={(file) => setFieldValue("bannerImage", file)}
                                            error={errors.bannerImage}
                                            touched={touched.bannerImage}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-4">
                                        <div className="d-flex flex-column mb-3 " style={{ gap: "10px" }}>
                                            <div className={`menu-row p-4 ${values.showInHome ? "active" : "inActive"}`}
                                                onClick={() =>
                                                    setFieldValue("showInHome", !values.showInHome)
                                                }
                                            >
                                                {values.showInHome ? (
                                                    <CheckSquare size={20} className="icon-active" />
                                                ) : (
                                                    <Square size={20} className="icon" />
                                                )}
                                                <span className="menu-title">Show In Home</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <SwitchToggle
                                            checked={values.isActive}
                                            onChange={(val) => setFieldValue("isActive", val)}
                                        />
                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <Button type="submit" color="primary" disabled={loading}>
                                        {loading ? (
                                            <span className="d-inline-flex align-items-center gap-2">
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>

                                    <Button
                                        color="danger"
                                        onClick={() => navigator(-1)}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddSubcategory
